import { render, staticRenderFns } from "./userHelp.vue?vue&type=template&id=0d8aabb0&scoped=true"
import script from "./userHelp.vue?vue&type=script&lang=js"
export * from "./userHelp.vue?vue&type=script&lang=js"
import style0 from "./userHelp.vue?vue&type=style&index=0&id=0d8aabb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8aabb0",
  null
  
)

export default component.exports